import { isValidEventSlug } from './string';

/**
 * Web site base URL (.env: REACT_APP_WEB_URL). Trailing slash yok.
 */
export const getWebBaseUrl = () => {
  const raw =
    process.env.REACT_APP_WEB_URL ||
    process.env.REACT_APP_WEBSITE_URL ||
    'https://www.gisekibris.com';
  return String(raw).replace(/\/$/, '');
};

/** Panel / web: gecerli slug varsa slug, yoksa id */
export const getEventRouteKey = (eventOrId) => {
  if (eventOrId == null || eventOrId === '') return '';
  if (typeof eventOrId === 'string' || typeof eventOrId === 'number') {
    return String(eventOrId);
  }
  if (isValidEventSlug(eventOrId.slug)) return eventOrId.slug;
  return eventOrId.id ? String(eventOrId.id) : '';
};

/**
 * Etkinlik public / preview linki.
 * Gecerli slug varsa slug; degilse id (fallback).
 */
export const getEventWebPath = (event, { preview = false } = {}) => {
  if (!event) return getWebBaseUrl();
  const key = getEventRouteKey(event);
  const path = `${getWebBaseUrl()}/etkinlikler/${encodeURIComponent(key)}`;
  return preview ? `${path}?mode=preview` : path;
};

export const getEventPreviewUrl = (event) => getEventWebPath(event, { preview: true });
